export default __webpack_public_path__ + "static/media/eclipsion.a525743f.webp";